<div class="patients" [class.patients--has-selection]="!!selectedMrn()">
  <header class="patients__brand-bar">
    <img src="/scryber-logo-lime.png?v=4" alt="Scryber" />
    @if (selectedMrn()) {
      <button type="button" class="patients__bar-btn" (click)="onBarNewVisit()">New Visit</button>
    } @else {
      <button type="button" class="patients__bar-btn" (click)="showAddPatientModal()">Add Patient</button>
    }
  </header>
  <aside class="patients__list-pane">
    <div class="patients__list-toolbar">
      <button type="button" class="patients__new" (click)="showAddPatientModal()">+ Add Patient</button>
      <div class="patients__list-tools">
        <label class="patients__active">
          <input type="checkbox" [ngModel]="activeOnly()" (ngModelChange)="activeOnly.set($event)" />
          Active patients
        </label>
        <button
          type="button"
          class="patients__icon-btn"
          aria-label="Search"
          (click)="searchOpen.set(!searchOpen())">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="11" cy="11" r="7" />
            <path d="M21 21l-4.3-4.3" />
          </svg>
        </button>
      </div>
      @if (searchOpen()) {
        <input
          class="patients__search"
          type="search"
          placeholder="Search patients"
          [ngModel]="searchText()"
          (ngModelChange)="searchText.set($event)" />
      }
    </div>

    @if (loading()) {
      <p class="patients__muted">Loading patients…</p>
    } @else if (error()) {
      <p class="patients__error">{{ error() }}</p>
    } @else if (!groups().length) {
      <div class="patients__empty">
        <p>No patients yet.</p>
      </div>
    } @else {
      <div class="patients__groups">
        @for (group of groups(); track group.label) {
          <div class="patients__group">
            <h2 class="patients__group-label">{{ group.label }}</h2>
            <div class="patients__group-cards">
              @for (patient of group.patients; track patient.mrn) {
                <button
                  type="button"
                  class="patients__card"
                  [class.patients__card--selected]="selectedMrn() === patient.mrn"
                  (click)="selectPatient(patient)">
                  <div class="patients__card-title">{{ patientLabel(patient) }}</div>
                  <div class="patients__card-meta">{{ metaLine(patient) }}</div>
                  <div class="patients__card-status" [class.is-active]="patient.active">
                    {{ patient.active ? 'Active' : 'Inactive' }}
                  </div>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </aside>

  <section class="patients__detail-pane">
    @if (!selectedMrn()) {
      <div class="patients__landing">
        <h1 class="patients__landing-title">Select a patient</h1>
        <p class="patients__landing-copy">Choose someone from the list to view their chart, or add a new patient.</p>
      </div>
    } @else {
      <button
        type="button"
        class="patients__back"
        aria-label="Back to patients"
        (click)="onMobileBack()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M15 18 9 12l6-6" />
        </svg>
      </button>
      <app-patient-summary
        [patientKey]="selectedMrn()!"
        [embedded]="true"
        [hideClinicalNotes]="true" />
    }
  </section>
</div>

<app-patient-modal
  [mode]="'add'"
  [visible]="displayPatientModal"
  [patient]="null"
  (visibleChange)="displayPatientModal = $event"
  (patientSaved)="onPatientSaved($event)">
</app-patient-modal>
